import React, { forwardRef } from "react";
import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";
import { INK, INK_HOVER, RADIUS_BUTTON } from "../../Utils/designTokens";

interface CLoadingButtonProps extends LoadingButtonProps {
  sx?: SxProps;
}

// CRL-3241: global black/white button styles
const defaultSx: SxProps<Theme> = {
  height: "48px",
  borderRadius: RADIUS_BUTTON,
  backgroundColor: INK,
  color: "#FFFFFF",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "initial",
  whiteSpace: "nowrap",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: INK_HOVER,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    background: "#E7EBF1",
    color: "#A7B0BF",
  },
  // loading: hide the label, only the spinner stays visible
  "&.MuiLoadingButton-loading.Mui-disabled": {
    color: "transparent",
  },
  "& .MuiLoadingButton-loadingIndicator": {
    color: "#A7B0BF",
  },
};

const outlinedSx: SxProps<Theme> = {
  height: "48px",
  borderRadius: RADIUS_BUTTON,
  backgroundColor: "white",
  color: INK,
  fontSize: "16px",
  fontWeight: 600,
  border: `1px solid ${INK}`,
  whiteSpace: "nowrap",
  textTransform: "initial",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#F8FAFC",
    border: `1px solid ${INK}`,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    background: "#E7EBF1",
    color: "#A7B0BF",
    border: "1px solid #E7EBF1",
  },
  // loading: hide the label, only the spinner stays visible
  "&.MuiLoadingButton-loading.Mui-disabled": {
    color: "transparent",
  },
  "& .MuiLoadingButton-loadingIndicator": {
    color: "#A7B0BF",
  },
};
const CLoadingButton = forwardRef<HTMLButtonElement, CLoadingButtonProps>(
  (props, ref) => {
    const { variant, sx, children, ...otherProps } = props;

    // Variant'a bağlı olarak doğru stili seçin
    const appliedSx = variant === "outlined" ? outlinedSx : defaultSx;
    return (
      <LoadingButton
        ref={ref}
        {...otherProps}
        variant={variant}
        sx={{
          ...appliedSx,
          ...sx, // Allow custom sx to override the default styles
        }}
      >
        {children}
      </LoadingButton>
    );
  }
);

export default CLoadingButton;
